type StackColumn = { label: string; title: string; body: string };

type Props = {
    eyebrow?: string;
    authorNote: string;
    heading: string;
    intro: string;
    columns: StackColumn[];
    backstop: string;
};

// Full-bleed dark editorial block for a guide's "what I actually run"
// section — three job-by-job picks plus a paper-backstop callout. Shares
// the outer band/route-line/byline chrome with GuideOpinionLead but the
// body is a stack of picks rather than numbered opinion points.
export default function GuideStackLead({
    eyebrow = "My stack",
    authorNote,
    heading,
    intro,
    columns,
    backstop,
}: Props) {
    return (
        <section className="gt-guide-opinion">
            <svg
                className="gt-guide-opinion__route"
                viewBox="0 0 900 60"
                preserveAspectRatio="none"
                aria-hidden="true"
            >
                <path d="M-10 40 Q 220 8 460 26 T 920 16" />
            </svg>
            <div className="gt-guide-opinion__inner">
                <div className="gt-guide-opinion__byline">
                    <span className="gt-guide-opinion__avatar" aria-hidden="true">
                        S
                    </span>
                    <div>
                        <div className="gt-eyebrow gt-guide-opinion__eyebrow">
                            {eyebrow}
                        </div>
                        <div className="gt-guide-opinion__note">{authorNote}</div>
                    </div>
                </div>
                <h2 className="gt-guide-opinion__heading">{heading}</h2>
                <p className="gt-guide-opinion__intro">{intro}</p>
                <div className="gt-guide-stack">
                    {columns.map((col) => (
                        <div key={col.label} className="gt-guide-stack__col">
                            <div className="gt-eyebrow gt-guide-stack__label">
                                {col.label}
                            </div>
                            <h3 className="gt-guide-stack__title">{col.title}</h3>
                            <p className="gt-guide-stack__body">{col.body}</p>
                        </div>
                    ))}
                </div>
                <div className="gt-guide-backstop">
                    <span aria-hidden="true">🖨</span>
                    <p>
                        <b>The backstop:</b> {backstop}
                    </p>
                </div>
            </div>
        </section>
    );
}
